import { useEffect, useLayoutEffect } from 'react';

import { isClientSide } from '@r1-frontend/shared/helpers/ssr';

export const useIsomorphicLayoutEffect = isClientSide() ? useLayoutEffect : useEffect;
